import {getCurrentYear} from '../../utils/commons'
import TopProduktVergleichLogo from './logo'
import {topProduktVergleichStylesDE} from './styles'

const baseConfig = {
  domainName: 'topproduktvergleich' as const,
  domainType: 'eu' as const,
  siteName: 'Top Produkt Vergleich',
  favicon: '/favicons/topproduktvergleich.png',
  styles: topProduktVergleichStylesDE,
}

const localeConfigs = {
  de: {
    measurementId: 'G-BFP0L47PN2',
    camelCaseUrl: 'TopProduktVergleich.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} | Besten Produkte im Vergleich`,
    description: (category?: string, count?: string) =>
      `Finde die besten ${count} ${category} im Vergleich ${getCurrentYear()} auf top-produkt-vergleich.com. Klare Rankings & Kaufempfehlungen – jetzt sparen`,
    logo: <TopProduktVergleichLogo className="size-10 shrink-0 tablet:size-8" locale="de" />,
  },
}

export const createConfig = (locale: string = 'de') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.de
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
